var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import classNames from "classnames";
import { useLoadImage } from "./utils/functions";
// styles
import "./lazyImage.scss";
// use the optional prop interface to define the default props
export const defaultProps = {
    dataTestId: "tecma-lazyImage",
    load: true,
    width: undefined,
    height: undefined,
    loadDelay: undefined,
    viewDelay: undefined,
    loadingElement: undefined,
    errorElement: undefined,
    onLoad: undefined,
    onError: undefined,
    children: undefined,
};
const LazyImageBackground = React.memo((_a) => {
    var { id, className, src, dataTestId, style, width, height, loadDelay, viewDelay, loadingElement, errorElement, onLoad, onRendered, onError, load, children } = _a, rest = __rest(_a, ["id", "className", "src", "dataTestId", "style", "width", "height", "loadDelay", "viewDelay", "loadingElement", "errorElement", "onLoad", "onRendered", "onError", "load", "children"]);
    const classList = classNames("tecma-lazyImage", className);
    const hasInitialError = !src;
    const { loaded, hasError } = useLoadImage({
        hasInitialError,
        load,
        onLoad,
        onError,
        loadDelay,
        viewDelay,
        id,
        src,
    });
    useEffect(() => {
        if (loaded && onRendered) {
            onRendered();
        }
    });
    return (_jsxs("div", Object.assign({ id: id, className: classList, "data-testid": dataTestId, role: "img", style: Object.assign(Object.assign({}, style), { width,
            height, backgroundImage: loaded && !hasError ? `url("${src}")` : "none" }) }, rest, { children: [loaded ? children : loadingElement || _jsx("div", { children: "Loading ..." }), hasError && (errorElement || "Error")] })));
});
const LazyImageImage = React.memo((_a) => {
    var { id, className, src, dataTestId, style, width, height, loadDelay, viewDelay, loadingElement, errorElement, onLoad, onRendered, onError, load, children, alt } = _a, rest = __rest(_a, ["id", "className", "src", "dataTestId", "style", "width", "height", "loadDelay", "viewDelay", "loadingElement", "errorElement", "onLoad", "onRendered", "onError", "load", "children", "alt"]);
    const classList = classNames("tecma-lazyImage", className);
    const hasInitialError = !src;
    const { loaded, hasError } = useLoadImage({
        hasInitialError,
        load,
        onLoad,
        onError,
        loadDelay,
        viewDelay,
        id,
        src,
    });
    useEffect(() => {
        if (loaded && onRendered) {
            onRendered();
        }
    });
    return (_jsxs(_Fragment, { children: [!loaded && (_jsx("span", { id: id, className: classList, "data-testid": dataTestId, style: Object.assign(Object.assign({}, style), { width, height }), children: loadingElement || "Loading..." })), loaded && !hasError && (_jsx("img", Object.assign({ id: id, className: classList, "data-testid": dataTestId, src: src, width: width, height: height, style: Object.assign({}, style), alt: alt }, rest))), hasError && (_jsx("span", { id: id, className: classList, "data-testid": dataTestId, style: Object.assign({}, style), children: errorElement || "Error" }))] }));
});
LazyImageBackground.defaultProps = defaultProps;
LazyImageImage.defaultProps = Object.assign(Object.assign({}, defaultProps), { alt: "" });
const LazyImage = { Background: LazyImageBackground, Image: LazyImageImage };
export default LazyImage;
